<template>
<div class="container">
    <div class="all">
        <div style="display:flex;align-items: center;">
            <div class="title">会员活动</div>
            <img width="15px" height="15px" src="../../../../assets/icon/icon-member.png" alt="" />
        </div>

<!--        <div class="more">更多-->
<!--            <span @click="gohaier"><img width="100%" src="@/assets/icon/more.png" alt=""></span>-->
<!--        </div>-->
    </div>
    <div class="swiper">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="#39a9ed">
            <van-swipe-item v-for="(item, index) in cmsData.bannerList" :key="index">
                <van-image fit="cover" :src="item.img" @click="detail(item.id)" />
            </van-swipe-item>
        </van-swipe>
    </div>
</div>
</template>

<script>
export default {
    components: {},
    props: ["cmsData"],
    data() {
        return {};
    },
    watch: {},
    computed: {},
    methods: {
        detail(id) {
            this.$router.push({
                path: "/productDetails?id=" + id,
            });
        },
        gohaier() {
            // window.location.href = "https://bbs.haier.com/activity/"
        }
    },
    created() {},
    mounted() {},
};
</script>

<style lang="scss" scoped>
.more {
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    // font-size: 30px;

    span {
        img {
            width: 40px;
            height: 40px;
            display: block;
            padding-left: 10px;
        }
    }
}

.container {
    // background: #fff;
    margin-top: 10px;
}

.all {
    padding: 20px;

    display: flex;
    justify-content: space-between;
}

.title {
    color: #333;
    // margin: 0 auto;
    // text-align: center;
    font-size: 33px;
    font-weight: bold;
    padding-right: 10px;
}

.swiper {
    width: 95%;
    // height: 400px;
    margin: 0 auto;
}

.my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    line-height: 150px;
    text-align: center;
}

/deep/.van-image__img {
    width: 100%;
    border-radius: 20px;

    // height: 400px;
}
</style>
